import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';

interface EstatePlanningWorkflowReviewDTO {
  HouseholdInformation: {
    HasSpouse: boolean;
    PrincipalName: string;
    SpouseName: string | null;
    SpouseAge: number;
    PrincipalAge: number;
    HasChildren: boolean;
    Children: string;
    Trusts: {
      Name: string;
      Value: number;
    }[];
  };

  EstateTaxRate: {
    FilingState: number | null;
    StateTaxRate?: number;
    StateTaxLowerLimitAmount?: number;
    FederalTaxRate: number;
    FederalTaxLowerLimitAmount: number;
    PortabilityElection: boolean;

    SpouseFederalTaxLowerLimitAmount?: number;
    SpouseFederalTaxRate?: number;
    SpouseFilingState: number | null;
    SpouseStateTaxLowerLimitAmount?: number;
    SpouseStateTaxRate: number | null;
  };

  DeductionAndGifts: {
    PrincipalAdministrationExpenseDeductionAmount: number;
    PrincipalLifetimeGiftingExemptionUsedAmount: number;
    SpouseAdministrationExpenseDeductionAmount: number | null;
    SpouseLifetimeGiftingExemptionUsedAmount: number | null;
  };

  Accounts: {
    LiquidCount: number;
    TotalAmount: number;
    TotalCount: number;
    IncludedInGrossEstateCount: number;
  };

  Assets: {
    IlliquidCount: number;
    TotalAmount: number;
    TotalCount: number;
    IncludedInGrossEstateCount: number;
  };

  LifeInsurances: {
    Owner: string;
    Insured: string;
    CashValue: number;
    DeathBenefit: number;
    IncludeInGrossEstate: boolean;
  }[];

  StateSpecificInfo?: {
    ApplicableExclusionAmount: number;
    FilingState: number | null;
    InheritanceTax: boolean;
    PortabilityElection: boolean;
    StateTaxRate: number;

    SpouseInheritanceTax: number | null;
    SpouseApplicableExclusionAmount: number | null;
  };
}

interface FetchParams {
  clientId: string;
}

export const fetchEstatePlanningWorkflowReview = async ({
  clientId,
}: FetchParams): Promise<EstatePlanningWorkflowReviewDTO> => {
  return authFetch(urlWithParams('/Consumer/EstatePlanningWorkflow/Review', { clientId }));
};

interface QueryParams {
  clientId: string;
}

export const useEstatePlanningWorkflowReviewQuery = ({ clientId }: QueryParams) => {
  return useQuery(
    queryKeys.estatePlanningWorkflowReview(clientId),

    () => fetchEstatePlanningWorkflowReview({ clientId }),

    {
      cacheTime: 0,
    },
  );
};
